import { Card, Col } from "reactstrap";
import PushNotificationHeader from "./push-notification-header/PushNotificationHeader";
import SentContent from "./push-notification-right-side/SentContent";
import { PushNotificationData } from "./types";

interface PushNotificationRightSideProps {
  setComposePushNotification: (value: boolean) => void;
  searchWord: string;
  setSearchWord: (value: string) => void;
  pushNotifications: PushNotificationData[];
}

const PushNotificationRightSide: React.FC<PushNotificationRightSideProps> = ({
  setComposePushNotification,
  searchWord,
  setSearchWord,
  pushNotifications,
}) => {
  return (
    <Col xxl="12">
      <div className="email-right-aside">
        <Card className="email-body email-list">
          <PushNotificationHeader
            searchWord={searchWord}
            setSearchWord={setSearchWord}
            setComposePushNotification={setComposePushNotification}
          />
          <SentContent
            pushNotifications={pushNotifications}
            searchWord={searchWord}
          />
        </Card>
      </div>
    </Col>
  );
};

export default PushNotificationRightSide;
